import { ApiEffects } from './api.effects';
import { EffectsModule } from '@ngrx/effects';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { JsonToXmlInterceptor } from './interceptor/json-to-xml.interceptor';
import { LogInterceptor } from './interceptor/log.interceptor';
import { MD5RequestInterceptor } from './interceptor/md5-request.interceptor';
import { NgModule } from '@angular/core';

@NgModule({
	declarations: [],
	imports: [EffectsModule.forFeature([ApiEffects])],
	providers: [
		{
			multi: true,
			provide: HTTP_INTERCEPTORS,
			useClass: LogInterceptor,
		},
		{
			multi: true,
			provide: HTTP_INTERCEPTORS,
			useClass: JsonToXmlInterceptor,
		},
		{
			multi: true,
			provide: HTTP_INTERCEPTORS,
			useClass: MD5RequestInterceptor,
		},
	],
})
export class ApiModule {}
